<template>
  <footer class="footer">

    <!-- Top: brand + nav columns -->
    <div class="footer__inner footer__top">

        <!-- Brand / contacts -->
        <div class="footer__brand" v-reveal.left>
          <div class="footer__org">
            <img src="@/assets/img/logos/uzb_gerb.png" :alt="$t('common.gerbAlt')" class="footer__emblem" />
            <span class="footer__org-divider"></span>
            <p class="footer__org-name">{{ $t('common.orgName') }}</p>
          </div>

          <ul class="footer__contacts">
            <li v-for="phone in phones" :key="phone">
              <a :href="`tel:${phone.replace(/\s|\(|\)|-/g, '')}`" :aria-label="$t('footer.callAria', { phone })">
                <img src="@/assets/img/logos/phone.svg" alt="" />
                {{ phone }}
              </a>
            </li>
            <li v-for="email in emails" :key="email">
              <a :href="`mailto:${email}`" :aria-label="$t('footer.emailAria', { email })">
                <img src="@/assets/img/logos/email.svg" alt="" />
                {{ email }}
              </a>
            </li>
          </ul>
        </div>

        <!-- Nav columns -->
        <nav class="footer__nav" v-reveal.stagger>
          <div class="footer__col" v-for="col in columns" :key="col.titleKey">
            <h4 class="footer__col-title">{{ $t(col.titleKey) }}</h4>
            <ul class="footer__links">
              <li v-for="link in col.links" :key="link.to">
                <router-link :to="link.to">{{ $t(link.labelKey) }}</router-link>
              </li>
            </ul>
          </div>
        </nav>

      </div>

    <!-- Bottom: full-width divider + copyright + socials -->
    <div class="footer__bottom">
      <div class="footer__inner footer__bottom-row">
        <p class="footer__copy">{{ $t('footer.copyright') }}</p>
        <ul class="footer__socials">
          <li v-for="s in socials" :key="s.alt">
            <a :href="s.url" target="_blank" rel="noopener">
              <img :src="s.icon" :alt="s.alt" />
            </a>
          </li>
        </ul>
      </div>
    </div>

  </footer>
</template>

<script>
import tg       from '@/assets/img/logos/tg.svg'
import insta    from '@/assets/img/logos/insta.svg'
import facebook from '@/assets/img/logos/facebook.svg'
import youtube  from '@/assets/img/logos/youtube.svg'

const FALLBACK_PHONES = ['+998 (55) 519-02-02']
const FALLBACK_EMAILS = ['nazorat@trm.uz']

export default {
  name: 'FooterPart',
  computed: {
    contacts() { return this.$store.getters['settings/contacts'] || {} },
    phones() {
      const p = this.contacts.phones
      return Array.isArray(p) && p.length ? p : FALLBACK_PHONES
    },
    emails() {
      const e = this.contacts.emails
      return Array.isArray(e) && e.length ? e : FALLBACK_EMAILS
    }
  },
  created() {
    this.$store.dispatch('settings/fetchContacts')
  },
  data() {
    return {
      columns: [
        {
          titleKey: 'nav.markaz',
          links: [
            { labelKey: 'nav.markazHaqida',         to: '/markaz/markaz-haqida' },
            { labelKey: 'nav.rahbariyat',           to: '/markaz/rahbariyat' },
            { labelKey: 'nav.boshqarmaBoshliqlari', to: '/markaz/boshqarma-boshliqlari' },
            { labelKey: 'nav.tuzilma',              to: '/markaz/tuzilma' }
          ]
        },
        {
          // only the pages with content; the placeholders stay out of the footer
          titleKey: 'nav.ilmiyMetodik',
          links: [
            { labelKey: 'nav.yoshOlimlar',     to: '/ilmiy-metodik/yosh-olimlar' },
            { labelKey: 'nav.ilmiyMaqolalar',  to: '/ilmiy-metodik/ilmiy-maqolalar' }
          ]
        },
        {
          titleKey: 'nav.hujjatlar',
          links: [
            { labelKey: 'nav.prezidentFarmonlari',  to: '/hujjatlar/prezident-farmonlari' },
            { labelKey: 'nav.talimgaOidQonunlar',   to: '/hujjatlar/talimga-oid' },
            { labelKey: 'nav.vazirlarMahkamasi',    to: '/hujjatlar/vazirlar-mahkamasi' },
            { labelKey: 'nav.talimgaDoirHujjatlar', to: '/hujjatlar/markaz-faoliyati' }
          ]
        },
        {
          titleKey: 'nav.axborot',
          links: [
            { labelKey: 'nav.savolJavob',      to: '/axborot/savol-javob' },
            { labelKey: 'nav.ochiqMalumotlar', to: '/axborot/ochiq-malumotlar' },
            { labelKey: 'nav.yangiliklar',     to: '/axborot/yangiliklar' },
            { labelKey: 'nav.galereya',        to: '/axborot/galereya' }
          ]
        }
      ],
      socials: [
        { icon: tg,       url: 'https://t.me/trm_uz', alt: 'Telegram' },
        { icon: insta,    url: 'https://www.instagram.com/trm_uz', alt: 'Instagram' },
        { icon: facebook, url: 'https://www.facebook.com/trmuz/', alt: 'Facebook' },
        { icon: youtube,  url: 'https://www.youtube.com/@trm_uz', alt: 'YouTube' }
      ]
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/components/07footer/footer.scss';
</style>
